export default {
  Resume: {
    download: 'Download',
    hireMe: 'Hire me',
    workExperienceAndEducation: 'Work experience & Education',
    years: ' years',
    year: ' year',
    skills: 'Skills',
    languages: 'Languages',
    interests: 'Interests',
    resume: 'Resume',
    projectsAndDevelopments: 'Projects & developments',
    showMore: 'Show more',
    showLess: 'Show less',
  },
  WaitingUntilJapanScreen: {
    remainingDaysUntilJapan: 'Remaining days until Japan',
    from: 'From',
    until: 'Until',
    days: 'Days',
    Percent: 'Percent',
  },
  SimpleBottomNavigation: {
    aboutMe: 'About me',
    home: 'Home',
    workExperience: 'Experience',
    education: 'Education',
    skills: 'Skills',
    languages: 'Languages',
    hobbies: 'Hobbies',
    projects: 'Projects',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en.js